import { useState } from 'react';

// our components
import ColumnItem from 'components/DataTable/ColumnItem';
import ColumnVerticalHeader from 'components/DataTable/ColumnVerticalHeader';
import DataTable from 'components/DataTable/DataTable';
import Loader from 'components/Loader';
import PreviewKeyAction from 'components/Modal/KeyActions/PreviewKeyAction';

// our hooks
import useGetKeyActions from 'hooks/keyActions/useGetKeyActions';

// our utils
import formatKeyActionName from 'shared/utils/formatting/keyaction/formatKeyActionName';
import formatDate from 'shared/utils/date/formatDate';

function SentKeyActions() {
	const [isKeyActionOpen, setIsKeyActionOpen] = useState(false);
	const [keyActionInfo, setKeyActionInfo] = useState(null);

	const {
		data: keyActions,
		isLoading: keyActionsLoading,
		isSuccess: keyActionsSuccess
	} = useGetKeyActions(
		(keyActionData) => {
			return keyActionData.map((keyAction) => ({
				...keyAction,
				clientFullName: `${keyAction.clientFirstName} ${keyAction.clientLastName}`,
				advisorFullName: `${keyAction.advisorFirstName} ${keyAction.advisorLastName}`,
				keyActionName: keyAction.type
			}));
		},
		{
			status: 'SENT'
		}
	);

	const clientFullNameKey = 'clientFullName';
	const tradelineIdKey = 'tradelineId';
	const keyActionNameKey = 'keyActionName';
	const advisorFullNameKey = 'advisorFullName';
	const advisorCompanyKey = 'advisorCompanyName';
	const dateQualifiedKey = 'qualifiedDate';
	const dateSentKey = 'sentDate';

	const columnsAdvisors = [
		ColumnItem(clientFullNameKey, 'Client Full Name', 1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		}),
		ColumnItem(tradelineIdKey, 'Tradeline ID', 1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		}),
		ColumnItem(keyActionNameKey, 'Key Action Name', 1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			),
			valueFormatter: ({ value }) => {
				return formatKeyActionName(value);
			}
		}),
		ColumnItem(dateQualifiedKey, 'Date Qualified', 1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			),
			valueFormatter: ({ value }) => {
				return formatDate(value, 'MM/dd/yyyy');
			}
		}),
		ColumnItem(advisorFullNameKey, 'Advisor Full Name', 1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		}),
		ColumnItem(advisorCompanyKey, 'Advisor Company', 1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		}),
		ColumnItem(dateSentKey, 'Date Sent', 1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		})
	];

	if (keyActionsLoading) {
		return <Loader />;
	}

	if (keyActionsSuccess) {
		return (
			<>
				<DataTable
					columns={columnsAdvisors}
					rows={keyActions}
					disableSelectionOnClick
					rowsPerPageOptions={10}
					handleRowClick={(row) => {
						setKeyActionInfo(row);
						setIsKeyActionOpen(true);
					}}
				/>
				{isKeyActionOpen && (
					<PreviewKeyAction
						keyActionInfo={keyActionInfo}
						isOpen={isKeyActionOpen}
						handleClose={() => setIsKeyActionOpen(false)}
					/>
				)}
			</>
		);
	}
}

export default SentKeyActions;
